<template>
<div>11</div>
</template>

<script>
export default {
  name: 'index'
}
</script>

<style scoped>

</style>
